import { GUARANTEE_DIRECTIONS, GUARANTEE_STATUSES, GUARANTEE_TYPES } from '@sahab/contracts'
import { z } from 'zod'

/** The claim print (`…/claims/$claimId/print`): which document, and print as soon as it is ready. */
export const claimPrintSearchSchema = z.object({
  doc: z.enum(['certificate', 'application']).optional().catch(undefined),
  print: z.coerce.boolean().optional().catch(undefined),
})

/** Contract reconciliation (`/projects/reconciliation`): the date (today when absent). */
export const reconciliationSearchSchema = z.object({
  asOf: z.iso.date().optional().catch(undefined),
})

/**
 * The guarantees register (`/projects/guarantees`): the filters, and the contingent-liabilities view
 * as at a date (today when absent). Prefixed names: other routes' `type` and `status` differ.
 */
export const guaranteeRegisterSearchSchema = z.object({
  bondView: z.enum(['register', 'contingent']).optional().catch(undefined),
  bondDirection: z.enum(GUARANTEE_DIRECTIONS).optional().catch(undefined),
  bondType: z.enum(GUARANTEE_TYPES).optional().catch(undefined),
  bondStatus: z.enum(GUARANTEE_STATUSES).optional().catch(undefined),
  expiringWithin: z.coerce.number().int().min(0).max(365).optional().catch(undefined),
  /** One project's guarantees. */
  bondProject: z.uuid().optional().catch(undefined),
  /** Text in the guarantee number, the bank or the counterparty (the API's `q`). */
  bondQ: z.string().trim().min(1).max(200).optional().catch(undefined),
  asOf: z.iso.date().optional().catch(undefined),
  /** The guarantee whose drawer is open over the register. */
  guarantee: z.string().min(1).max(100).optional().catch(undefined),
})
export type GuaranteeRegisterSearch = z.infer<typeof guaranteeRegisterSearchSchema>
